import { useConfirm } from "melco-shared-logic";

export const useConfirmAddInputFormat = (openFileDialog: () => void) => {
  return useConfirm(
    async () => {
      openFileDialog();
    },
    {
      translationPrefix: "inputFormats.actions.add",
    }
  );
};
